module.exports = __webpack_public_path__ + "static/media/ic_locate.b08a0b27.svg";